import React from 'react';
import Stats from './Stats';

const About = ({ data }) => {
   if (!data) return null;

   const { name, image, bio, phone, resumedownload } = data;

   return (
      <section id="about">
         <div className="row about-row">
            <div className="about-img-col">
               <img className="profile-pic" src={image} alt={`${name}'s Profile Pic`} />
            </div>
            <div className="nine columns main-col">
               <h2>About Me</h2>
               <p>{bio}</p>

               <Stats />

               <div className="row">
                  <div className="columns contact-details">
                     <h2>Contact Details</h2>
                     <p className="address">
                        <span>{name}</span>
                        <br />
                        <span>{phone}</span>
                        <br />
                        <span>
                           <a href="#contact" className="smoothscroll">
                              Email Me
                           </a>
                        </span>
                     </p>
                  </div>
                  <div className="columns download">
                     <p>
                        <a href={resumedownload} className="download-btn">
                           <i className="fa fa-download"></i> Download Resume
                        </a>
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default About;
